<div class="container  my-5">

    <div class="row " *ngIf="inicio">
        <div class="xol-md-12">
            <div id="glit" class="container">
                <h1 class="imgBW">Educación</h1>
                <div id="line"></div>
            </div>
        </div>
    </div>
    <div class="row">
        
        <div class="col-md-6 text-center">
            <img src="assets/img/publi11.jpeg"  class="rounded w-100" />
        </div>
        <div class="col-md-6 text-center">
            <img src="assets/img/publi22.jpeg"  class="rounded w-100" />
        </div>
    </div>
    <div class="row my-5" >
        <div class="col-12 col-md-12 ">
            <div class="social-box">
                <div class="container">
                    <div class="row  mx-5">

                        <div class="col-md-6 col-lg-6 col-xs-12 text-center init" (click)="abreEspecial()">
                            <a style="text-decoration: none;">
                                <div class="box">
                                    <i class="fa fa-behance fa-3x" aria-hidden="true"></i>
                                    <div class="box-title">
                                        <h3 class="fuenteTitulo">Educación Especial</h3>

                                    </div>
                                    <!-- <div class="box-text">
                                        <span></span>
                                    </div> -->
                                    <img src="assets/img/especial.jpg" style="width:200px;height: 150px;" class="rounded" />
                                </div>
                            </a>

                        </div>
                        <div class="col-md-6 col-lg-6 col-xs-12 text-center init" (click)="abreIntegral()">
                            <a style="text-decoration: none;">
                                <div class="box">
                                    <i class="fa fa-behance fa-3x" aria-hidden="true"></i>
                                    <div class="box-title">
                                        <h3 class="fuenteTitulo">Educación Integral</h3>
                                    </div>
                                    <!-- <div class="box-text">
                                        <span></span>
                                    </div> -->

                                    <img src="assets/img/integral.png" style="width:200px;height: 150px; background-color: white;" class="rounded" />

                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>




    </div>
</div>
<div class="container" *ngIf="especial">
 

      
       
        <div class="row">

            <div class="col-md-7 px-5" style="margin-top: 5%;">
                <div id="glit" class="container">
                    <h1 style="color: brown;">Educación Especial</h1>
                    <div id="line"></div>
                </div>
                <p style=" text-align: justify;">La educación Especial es el servicio educativo que ofrece atención con equidad a alumnos con discapacidad o bien aptitudes sobresalientes y de acuerdo con sus condiciones, necesidades, intereses y potencialidades.
                </p>
                <p style=" text-align: justify;">
                    Los Programas de Coordinación de educación Especial responden al derecho de las personas a la integracion social y del derecho de todos a una educacion de calidad que propicie el maximo desarrollo posible de las potencialidades propias.
                </p>
                <div class="col-md-12 my-5">
                    <div class="row tramites-home">
                        <div class="tramites-home col-12 mt-2">
                
                            <div class="views-element-container block block-views block-views-blocklistado-tramites-y-servicios-block-1"
                                id="block-views-block-listado-tramites-y-servicios-block-1-2">
                
                                <a (click)="abreAsesoria()" class="btn btn-debug">
                                    <h2 class="block-title colorSecundario">Asesoria psicologica especial</h2>
                                </a>
                
                                <div>
                                    <div
                                        class="view view-listado-tramites-y-servicios view-id-listado_tramites_y_servicios view-display-id-block_1 js-view-dom-id-ace45a4a7438a4b66a3d0ac2a4f4423379825705f2c36e351724c73b10fa8255">
                
                                        <div class="view-content">
                
                                            <ul>
                
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content">
                                                            <a href="#" hreflang="es">
                                                                Tiene como objetivo brindar herramientas a los niños y niñas
                                                                inscritos en el
                                                                Programa de Educación Integral
                                                                favoreciendo las necesidades de cada alumno(a).
                                                            </a></span>
                                                        <!-- Programa de Atención Psicopedagógica y Educación Especial, -->
                                                    </div>
                                                </li>
                
                                            </ul>
                
                                        </div>
                
                                    </div>
                                </div>
                
                            </div>
                
                        </div>
                
                
                    </div>
                
                
                </div>
                
                <div class="col-md-12 my-5">
                    <div class="row tramites-home">
                        <div class="tramites-home col-12 mt-2">
                
                            <div class="views-element-container block block-views block-views-blocklistado-tramites-y-servicios-block-1"
                                id="block-views-block-listado-tramites-y-servicios-block-1-2">
                
                                <h2 class="block-title colorSecundario">Detección temprana de autismo</h2>
                
                                <div>
                                    <div
                                        class="view view-listado-tramites-y-servicios view-id-listado_tramites_y_servicios view-display-id-block_1 js-view-dom-id-ace45a4a7438a4b66a3d0ac2a4f4423379825705f2c36e351724c73b10fa8255">
                
                                        <div class="view-content">
                
                                            <ul>
                
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content">
                                                            <a href="#" hreflang="es">
                                                                Tiene como objetivo identificar a los niños y niñas entre 2 y 5 años
                                                                que presenten signos de alerta del Trastorno del Espectro Autista,
                                                                para así canalizarlos, recibiendo un diagnóstico temprano para su
                                                                atención integral.
                
                                                            </a></span>
                                                    </div>
                                                </li>
                
                                            </ul>
                
                                        </div>
                
                                    </div>
                                </div>
                
                            </div>
                
                        </div>
                
                
                    </div>
                
                
                </div>
                <div class="col-md-12 my-5">
                    <div class="row tramites-home">
                        <div class="tramites-home col-12 mt-2">
                
                            <div class="views-element-container block block-views block-views-blocklistado-tramites-y-servicios-block-1"
                                id="block-views-block-listado-tramites-y-servicios-block-1-2">
                
                                <h2 class="block-title colorSecundario">Vínculos Asertivos</h2>
                               

                                    <div
                                        class="view view-listado-tramites-y-servicios view-id-listado_tramites_y_servicios view-display-id-block_1 js-view-dom-id-ace45a4a7438a4b66a3d0ac2a4f4423379825705f2c36e351724c73b10fa8255">
                
                                        <div class="view-content">
                
                                            <ul>
                
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content">
                                                            <a href="#" hreflang="es">
                                                                Tiene como objetivo proporcionar herramientas y estrategias
                                                                necesarias
                                                                a las familias y docentes de los niños y niñas con necesidades
                                                                educativas
                                                                especiales en edad escolar para fortalecer el desarrollo integral y
                                                                calidad
                                                                de vida de los mismos.
                
                                                            </a></span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="views-field views-field-title"><span class="field-content">
                                                            <a  hreflang="es">
                                                    <h5  style="color:#1a030fab;text-decoration:underline;cursor: pointer;" (click)="abreFotosAsertivas()">Ver Fotografias</h5>
                                                    </a></span>
                                                    </div>
                                                    <div class="row" *ngIf="fotosAsertivas">
                                                        <div class="row my-5">
                                                            <div class="col-md-12">
                                                                <h3 style="color:rgb(148, 152, 9)">TALLER DE FIN DE SEMANA</h3>
                                                                <img src="assets/img/educacionEspecial/asertivos/img15.jpg" class="rounded w-100" />
                                                            </div>
                                                            <div class="col-md-12">
                                                                <img src="assets/img/educacionEspecial/asertivos/img16.jpg" class="rounded w-100" />
                                                            </div>
                                                            <div class="col-md-12">
                                                                <img src="assets/img/educacionEspecial/asertivos/img17.jpg" class="rounded w-100" />
                                                            </div>
                                                            <div class="col-md-12">
                                                                <img src="assets/img/educacionEspecial/asertivos/img18.jpg" class="rounded w-100" />
                                                            </div>
                                                            <div class="col-md-12">
                                                                <img src="assets/img/educacionEspecial/asertivos/img19.jpg" class="rounded w-100" />
                                                            </div>
                                                        </div>
                                                        <div class="row my-5">
                                                            <div class="col-md-12">
                                                                <h3 style="color:rgb(148, 152, 9)">COMPRENDIENDO EL AUTISMO</h3>
                                                                <img src="assets/img/educacionEspecial/asertivos/img1.jpg" class="rounded w-100" />
                                                            </div>
                                                            <div class="col-md-12">
                                                                <img src="assets/img/educacionEspecial/asertivos/img2.jpg" class="rounded w-100" />
                                                            </div>
                                                            <div class="col-md-12">
                                                                <img src="assets/img/educacionEspecial/asertivos/img3.jpg" class="rounded w-100" />
                                                            </div>
                                                        </div>
                                                        <div class="row my-5">
                                                            <div class="col-md-12">
                                                                <h3 style="color:rgb(148, 152, 9)">ESTRATEGIAS DE INTERVENCIÓN EN EL HOGAR APOYOS VISUALES</h3>
                                                                <img src="assets/img/educacionEspecial/asertivos/img5.jpg" class="rounded w-100" />
                                                            </div>
                                                            <div class="col-md-12">
                                                                <img src="assets/img/educacionEspecial/asertivos/img6.jpg" class="rounded w-100" />
                                                            </div>
                                                            
                                                        </div>
                                                        <div class="row my-5">
                                                            <div class="col-md-12">
                                                                <h3 style="color:rgb(148, 152, 9)">ESTRATEGIAS DE INTERVENCIÓN EN EL HOGAR INTEGRACIÓN SENSORIAL</h3>
                                                                <img src="assets/img/educacionEspecial/asertivos/img8.jpg" class="rounded w-100" />
                                                            </div>
                                                            <div class="col-md-12">
                                                                <img src="assets/img/educacionEspecial/asertivos/img9.jpg" class="rounded w-100" />
                                                            </div>
                                                            <div class="col-md-12">
                                                                <img src="assets/img/educacionEspecial/asertivos/img10.jpg" class="rounded w-100" />
                                                            </div>
                                                        
                                                        </div>
                                                        <div class="row my-5">
                                                            <div class="col-md-12">
                                                                <h3 style="color:rgb(148, 152, 9)">ESTRATEGIAS DE INTERVENCIÓN EN EL HOGAR PSICOMOTRICIDAD</h3>
                                                                <img src="assets/img/educacionEspecial/asertivos/img11.jpg" class="rounded w-100" />
                                                            </div>
                                                            <div class="col-md-12">
                                                                
                                                                <img src="assets/img/educacionEspecial/asertivos/img13_.jpg" class="rounded w-100" />
                                                            </div>
                                                            
                                                        
                                                        </div>
                                                        <div class="row my-5">
                                                            <div class="col-md-12">
                                                                <h3 style="color:rgb(148, 152, 9)">PADRES PEREGRINOS, AFRONTANDO LA DISCAPACIDAD DE MI HIJO</h3>
                                                                <img src="assets/img/educacionEspecial/asertivos/img12.jpg" class="rounded w-100" />
                                                            </div>
                                                                <div class="col-md-12">
                                                                    
                                                                    <img src="assets/img/educacionEspecial/asertivos/img14.jpg" class="rounded w-100" />
                                                                </div>
                                                        
                                                        
                                                        </div>
                                                          
                                                           
                                                    </div>
                                                </li>
                
                                            </ul>
                
                                        </div>
                
                                    </div>
                               
                
                            </div>
                
                        </div>
                
                
                    </div>
                
                
                </div>
            </div>
            <div class="col-md-5 px-5">
                <div class="row" *ngIf="asesoria || especial">
                    <div class="col-md-12 px-5 my-5">
                        <h4>Requisitos</h4>
                        <p>Estar inscrito en el Programa de Educación Integral</p>
                        <!-- <p>2 Copias de acta de Nacimiento</p>
                            <p>2 Copias del CURP</p>
                            <p>2 Copias de INE de padre o tutor</p>
                            <p>2 Copias de comprobante de domicilio no mayor a 3 meses</p>
                            <p>2 Copias de calificaciones de ultimo grado de estudios</p> -->
                        <!-- <h5 class="mt-5">Horarios:</h5>
                            <p><strong>Matutino:</strong> De 8:00 am a 10:00 am y de 10:00 am a 12:00 pm</p>
                            <p><strong>Vespertino:</strong> De 2:00 pm a 4:00 pm y de 4:00 pm a 6:00 pm</p> -->
                        <h5 class="mt-5">Horarios:</h5>
                        <p><strong>Matutino:</strong> De 8:00 am a 10:00 am y de 10:00 am a 12:00 pm</p>
                        <p><strong>Vespertino:</strong> De 2:00 pm a 4:00 pm y de 4:00 pm a 6:00 pm</p>
                    </div>
                
                
                
                    <div class="row">
                        <div class="col-md-12 px-5">
                            <h4>Sedes</h4>
                            <p><strong>ESCUELA GENERAL IGNACIO ZARAGOZA</strong> Plutarco Elías Calles y Agustín de Iturbide S/N, Col.
                                Palacios </p>
                            <p><strong>ESCUELA PRIMARIA CENTENARIO DE LA CONSTITUCIÓN 1917</strong><br>Fundación Televisa S/N
                                Fraccionamiento Nuevo
                                Progreso
                            <p><strong>ESCUELA PRIMARIA CARLOS A. CARRILLO</strong><br>Av. Obregon y Peru S/N Col. Juarez</p>
                            <p><strong>ESC. PRIM FUNDADORES DE NUEVO LAREDO</strong><br>Obrero Mundial S/N Col. Infonavit Fundadores</p>
                            <!--<p><strong>SEDATU "EL PROGRESO"</strong><br>Calle Selene e Icaro, Col. El Progreso</p>-->
                            <p><strong>CASA DE LA CULTURA PALMARES</strong><br>Tampico #6200, Col. Palmares</p>
                            <p><strong>Prim. Rita Del Valle García Mat.</strong><br>Avenida 1 #1109, Entre Propiedad privada y calle
                                Josefa Ortiz de
                                Dominguez, Col. Blanca Navidad.
                            <p><strong>ESC. PRIM. VICENTE GUERRERO</strong><br>Plutarco Elias Calles y Agustin Iturbide S/N Col.
                                Palacios</p>
                            <p><strong>CENTRO COMUNITARIO "VILLAS DE SAN MIGUEL"</strong><br>San Baltasar #1102, Col. Villas de San
                                Miguel</p>
                            <p><strong>ESC. PRIM. CARMEN U. DE RENDON</strong><br>Calle Alvaro Obregon S/N, Col. Jardin</p>
                            <p><strong>SEDATU "El Progreso"</strong><br>Calle Selene e icaro, Col. El progreso</p>
                            <p><strong>Biblioteca Ruben Miranda</strong><br>Lincoln y Justo Sierra #802, Col. Viveros</p>
                            <p><strong>CENTRO COMUNITARIO CAMPO REAL</strong><br>Cerrada Campo Real S/N Col. Benito Juárez</p>
                            <p><strong>Casa de la Cultura Palmares</strong><br>Tampico #6200, Col. Palmares</p>
                            <p><strong>CENTRO COMUNITARIO "PANCHO VILLA"</strong><br>Iglesias Calderón S/N Col. Francisco Villa</p>
                            <!-- <h4>Matutino</h4>
                            <p><strong>Centro Juvenil "SILAO"</strong><br>Privada Colon #5710, Col. Las Torres</p>
                            <p><strong>SEDATU "El Progreso"</strong><br>Calle Selene e icaro, Col. El progreso</p>
                            <p><strong>SEDATU "Constitucional"</strong><br>Articulo 7 esquina con Prometeo</p>
                            <p><strong>Biblioteca Emiliano Zapata</strong><br>Calzada revolucion #7401, Col. Buena Vista</p>
                            <p><strong>Biblioteca Fidel Cuellar</strong><br>Dr Mier s/n, Col. Hidalgo (Dentro del parque Mendoza)</p>
                            <p><strong>Casa de la Cultura Palmares</strong><br>Tampico #6200, Col. Palmares</p>
                            <p><strong>Casa de la Cultura Polivalente</strong><br>Ayuntamiento sur #4980, Col. Infonavit</p> -->
                
                        </div>
                        <!-- <div class="col-md-6 px-5 my-5">
                            <h4>Vespertino</h4>
                            <p><strong>Centro Juvenil "SILAO"</strong><br>Privada Colon #5710, Col. Las Torres</p>
                            <p><strong>SEDATU "El Progreso"</strong><br>Calle Selene e icaro, Col. El progreso</p>
                            <p><strong>SEDATU "Constitucional"</strong><br>Articulo 7 esquina con Prometeo</p>
                            <p><strong>CEDEX (Escula Manuel Cavazos)</strong><br>Dr Mier #3030, Sector Centro</p>
                            <p><strong>Biblioteca Ruben Miranda</strong><br>Lincoln y Justo Sierra #802, Col. Viveros</p>
                            <p><strong>Biblioteca Emiliano Zapata</strong><br>Calzada Revolucion #7402, Col. Buena Vista</p>
                            <p><strong>Biblioteca Fidel Cuellar</strong><br>Dr Mier s/n, Col. Hidalgo (Dentro del parque Mendoza)</p>
                            <p><strong>Casa de la Cultura Palmares</strong><br>Tampico #6200, Col. Palmares</p>
                            <p><strong>Casa de la Cultura Polivalente</strong><br>Ayuntamiento sur #4980, Col. Infonavit</p>
                        </div> -->
                    </div>
                    <!-- Termina Especial -->
                </div>

             
            </div>
        </div>

    
   
</div>

<div class="container" *ngIf="integral">
    <div class="row">

        <!-- <br>
        <br>
        <br>
        <br>
        <br>
        <br> -->
      
     
        <div class="row">

            <div class="col-md-5 px-5" style="margin-top: 5%;">
                <div id="glit" class="container">
                    <h1 style="color: brown;">Educación Integral</h1>
                    <div id="line"></div>
                </div>
                <p style=" text-align: justify;">La educación siempre ha sido uno de los principales cimientos en el desarrollo de nuestros niños y niñas. Este ha sido un tema de constante preocupación e interés debido al impacto que tiene en diferentes áreas de la vida; ademas de que
                    mediante ella se puede llegar a garantizar un cambio favorable que proporcione una mejor calidad de vida, ya que la educacion es principalmente quien acompaña en la formacion de los próximos adultos responsables.
                </p>

            </div>
            <div class="col-md-7 px-5">
                <div class="col-md-12 my-5">
                    <div class="row tramites-home">
                        <div class="tramites-home col-12 mt-5">

                            <div class="views-element-container block block-views block-views-blocklistado-tramites-y-servicios-block-1" id="block-views-block-listado-tramites-y-servicios-block-1-2">

                                <h2 class="block-title colorSecundario mt-1">Atención Psicopedagógica y Educación Especial</h2>

                                <div>
                                    <div class="view view-listado-tramites-y-servicios view-id-listado_tramites_y_servicios view-display-id-block_1 js-view-dom-id-ace45a4a7438a4b66a3d0ac2a4f4423379825705f2c36e351724c73b10fa8255">

                                        <div class="view-content">

                                            <ul>

                                                <li class="">
                                                    <div class="views-field views-field-title"><span class="field-content">
                                                                <a href="#" hreflang="es">
                                                                   Tiene como objetivo ofrecer herramientas y estrategias adecuadas para
                                                                   fortalecer los factores académicos, sociales y emocionales de la niñez
                                                                   contribuyendo con la adquisición de buenos hábitos de estudio y bienestar
                                                                   psicológico, para evitar el rezago educativo de niñas y niños de 6 a 12 años
                                                                   ádemas de brindar atención a dificultades de aprendizaje, con atención 
                                                                   perzonaizada, según las necesidades del caso.
        
                                                                </a></span>
                                                    </div>
                                                </li>

                                            </ul>

                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>


                    </div>


                </div>


            </div>
        </div>
        <br>
        <br>
        <div class="row" *ngIf="integral">
            <div class="col-md-12 px-5 my-5">
                <h4>Requisitos</h4>
         <!--      <p>Estar inscrito en el Programa de Educación Integral</p>-->
                
                <p>2 Copias de acta de Nacimiento del Menor</p>
                <p>2 Copias del CURP</p>
                <p>2 Copias de la boleta de calificación</p>
                <p>2 Copias de INE de padre o tutor</p>
                <p>2 Copias del comprobante de domicilio</p>
                
                
                <h5 class="mt-5">Horarios:</h5>
                <p><strong>Matutino:</strong> De 8:00 am a 10:00 am y de 10:00 am a 12:00 pm</p>
                <p><strong>Vespertino:</strong> De 2:00 pm a 4:00 pm y de 4:00 pm a 6:00 pm</p>
             

            </div>


        </div>
        <div class="row" *ngIf="integral">
            <div class="col-md-6 px-5 my-5">
                <h4>Sedes</h4>
                
                    <p class="mt-3" style="cursor: pointer;"><strong>ESCUELA GENERAL IGNACIO ZARAGOZA</strong> Plutarco Elías Calles y Agustín de Iturbide S/N, Col. Palacios </p>
                    <div class="col-md-12">
                            <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS IGNACIO ZARAGOZA/img1.jpg"
                                class="w-100 rounded" />
                    </div>
                    <p class="mt-3" style="cursor: pointer;"><strong>ESCUELA PRIMARIA CENTENARIO DE LA CONSTITUCIÓN 1917</strong><br>Fundación Televisa S/N Fraccionamiento Nuevo
                        Progreso
                        <div class="col-md-12">
                            <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS CENTENARIO DE LA CONSTITUCION/img1.jpg"
                                class="w-100 rounded" />
                        </div>
                        <div class="col-md-12">
                            <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS CENTENARIO DE LA CONSTITUCION/img2.jpg"
                                class="w-100 rounded" />
                        </div>
                        <div class="col-md-12">
                            <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS CENTENARIO DE LA CONSTITUCION/img3.jpg"
                                class="w-100 rounded" />
                        </div>
                     <p class="mt-3" style="cursor: pointer;"><strong>ESCUELA PRIMARIA CARLOS A. CARRILLO</strong><br>Av. Obregon y Peru S/N Col. Juarez</p>
                     <p class="mt-3" style="cursor: pointer;"><strong>ESC. PRIM FUNDADORES DE NUEVO LAREDO</strong><br>Obrero Mundial S/N Col. Infonavit Fundadores</p>
                    <div class="col-md-12">
                        <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS FUNDADORES/img1.jpg" class="w-100 rounded" />
                    </div>
                    <div class="col-md-12">
                        <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS FUNDADORES/img2.jpg" class="w-100 rounded" />
                    </div>
                     <!--<p><strong>SEDATU "EL PROGRESO"</strong><br>Calle Selene e Icaro, Col. El Progreso</p>-->
                     <p class="mt-3" style="cursor: pointer;"><strong>CASA DE LA CULTURA PALMARES</strong><br>Tampico #6200, Col. Palmares</p>
                    <p class="mt-3" style="cursor: pointer;"><strong>Prim. Rita Del Valle García Mat.</strong><br>Avenida 1 #1109, Entre Propiedad privada y calle Josefa Ortiz de
                        Dominguez, Col. Blanca Navidad.
                        <div class="col-md-12">
                            <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS RITA DEL VALLE/img1.jpg" class="w-100 rounded" />
                        </div>
                        <div class="col-md-12">
                            <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS RITA DEL VALLE/img2.jpg" class="w-100 rounded" />
                        </div>
                        <div class="col-md-12">
                            <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS RITA DEL VALLE/img3.jpg" class="w-100 rounded" />
                        </div>
                    <p class="mt-3" style="cursor: pointer;"><strong>ESC. PRIM. VICENTE GUERRERO</strong><br>Plutarco Elias Calles y Agustin Iturbide S/N Col. Palacios</p>
                    <p class="mt-3" style="cursor: pointer;"><strong>CENTRO COMUNITARIO "VILLAS DE SAN MIGUEL"</strong><br>San Baltasar #1102, Col. Villas de San Miguel</p>
                    <div class="col-md-12">
                        <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS VILLAS DE SAN MIGUEL/img1.jpg" class="w-100 rounded" />
                    </div>
                    <p class="mt-3" style="cursor: pointer;"><strong>ESC. PRIM. CARMEN U. DE RENDON</strong><br>Calle Alvaro Obregon S/N, Col. Jardin</p>
                    <div class="col-md-12">
                        <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS CARMEN U. DE RENDON/img1.jpg"
                            class="w-100 rounded" />
                    </div>
                    <p class="mt-3" style="cursor: pointer;"><strong>SEDATU "El Progreso"</strong><br>Calle Selene e icaro, Col. El progreso</p>
                    <p class="mt-3" style="cursor: pointer;"><strong>Biblioteca Ruben Miranda</strong><br>Lincoln y Justo Sierra #802, Col. Viveros</p> 
                    <div class="col-md-12">
                        <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS_BIBLIOTECA_RUBEN_MIRANDA/img1.jpg" class="w-100 rounded" />
                    </div>
                    <p class="mt-3" style="cursor: pointer;"><strong>CENTRO COMUNITARIO CAMPO REAL</strong><br>Cerrada Campo Real S/N Col. Benito Juárez</p>
                    <div class="col-md-12">
                        <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS CAMPO REAL/img1.jpg"
                            class="w-100 rounded" />
                    </div>
                    <div class="col-md-12">
                        <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS CAMPO REAL/img2.jpg"
                            class="w-100 rounded" />
                    </div>
                    <p class="mt-3" style="cursor: pointer;"><strong>Casa de la Cultura Palmares</strong><br>Tampico #6200, Col. Palmares</p>
                    <p class="mt-3" style="cursor: pointer;"><strong>CENTRO COMUNITARIO "PANCHO VILLA"</strong><br>Iglesias Calderón S/N Col. Francisco Villa</p>
                    <div class="col-md-12">
                        <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS FRANCISCO VILLA/img1.jpg" class="w-100 rounded" />
                    </div>
                    <div class="col-md-12">
                        <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS FRANCISCO VILLA/img2.jpg" class="w-100 rounded" />
                    </div>
                    <div class="col-md-12">
                        <img src="https://nld.gob.mx/assets/img/educacionIntegral/FOTOS FRANCISCO VILLA/img3.jpg" class="w-100 rounded" />
                    </div>
                        
                   
                   
                   
                   
                <!-- <h4>Matutino</h4>
                <p><strong>Centro Juvenil "SILAO"</strong><br>Privada Colon #5710, Col. Las Torres</p>
                <p><strong>SEDATU "El Progreso"</strong><br>Calle Selene e icaro, Col. El progreso</p>
                <p><strong>SEDATU "Constitucional"</strong><br>Articulo 7 esquina con Prometeo</p>
                <p><strong>Biblioteca Emiliano Zapata</strong><br>Calzada revolucion #7401, Col. Buena Vista</p>
                <p><strong>Biblioteca Fidel Cuellar</strong><br>Dr Mier s/n, Col. Hidalgo (Dentro del parque Mendoza)</p>
                <p><strong>Casa de la Cultura Palmares</strong><br>Tampico #6200, Col. Palmares</p>
                <p><strong>Casa de la Cultura Polivalente</strong><br>Ayuntamiento sur #4980, Col. Infonavit</p> -->

            </div>
            <!-- <div class="col-md-6 px-5 my-5">
                <h4>Vespertino</h4>
                <p><strong>Centro Juvenil "SILAO"</strong><br>Privada Colon #5710, Col. Las Torres</p>
                <p><strong>SEDATU "El Progreso"</strong><br>Calle Selene e icaro, Col. El progreso</p>
                <p><strong>SEDATU "Constitucional"</strong><br>Articulo 7 esquina con Prometeo</p>
                <p><strong>CEDEX (Escula Manuel Cavazos)</strong><br>Dr Mier #3030, Sector Centro</p>
                <p><strong>Biblioteca Ruben Miranda</strong><br>Lincoln y Justo Sierra #802, Col. Viveros</p>
                <p><strong>Biblioteca Emiliano Zapata</strong><br>Calzada Revolucion #7402, Col. Buena Vista</p>
                <p><strong>Biblioteca Fidel Cuellar</strong><br>Dr Mier s/n, Col. Hidalgo (Dentro del parque Mendoza)</p>
                <p><strong>Casa de la Cultura Palmares</strong><br>Tampico #6200, Col. Palmares</p>
                <p><strong>Casa de la Cultura Polivalente</strong><br>Ayuntamiento sur #4980, Col. Infonavit</p>
            </div> -->
        </div>


    </div>
</div>